import { get, post, del } from '../utils/data';

const EmbedsApi = `html_embeds/`;

export const fetchExistingEmbeddedIntegrations = ({
  embeddedIntegrationsApiBaseUri,
  metaSiteId,
}) => {
  const apiBaseUrl = `${embeddedIntegrationsApiBaseUri}${EmbedsApi}`;
  return get({ apiBaseUrl })({ path: `${metaSiteId}?origin=marketing` });
};

export const setIntegrationData = (config, siteId, integrationData) => {
  const apiBaseUrl = `${config.embeddedIntegrationsApiBaseUri}${EmbedsApi}`;

  return post({
    apiBaseUrl,
    instance: config.instance,
  })({
    path: siteId,
    params: integrationData,
  });
};

export const deleteIntegrationData = (config, siteId, embedId) => {
  const apiBaseUrl = `${config.embeddedIntegrationsApiBaseUri}${EmbedsApi}`;

  return del({
    apiBaseUrl: `${apiBaseUrl}${siteId}/`,
    instance: config.instance,
  })({
    path: embedId,
  });
};
